import clipboard from "../../../../img/clipboard.svg";
import glasses from "../../../../img/glasses.svg";
import security from "../../../../img/security.svg";
import content from "../../../../content/content";

export const CARD = [
  {
    key: "flexible",
    img: clipboard,
    header: content.home.whyGruepr.flexibleHeader,
    info: content.home.whyGruepr.flexibleText,
    alt: "clipboard icon",
  },
  {
    key: "secure",
    img: security,
    header: content.home.whyGruepr.privacyHeader,
    info: content.home.whyGruepr.privacyText,
    alt: "shield icon",
  },

  {
    key: "for educators",
    img: glasses,
    header: content.home.whyGruepr.forEducatorsHeader,
    info: content.home.whyGruepr.forEducatorsText,
    alt: "glasses icon",
  },
];




